import React from 'react';
import {
    StyledTabContentContianer,
    TabContent,
    TabContentFont,
    TabSelectedBorder,
} from './InventoryTab.styled';
import { useSelector } from 'react-redux';
import { logErrorToConsole } from 'src/utils/util';

const InventoryTabList = ({ label, isTabActive, tabSwitch, id }) => {
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    return (
        <>
            <StyledTabContentContianer
            id="receivesets-inventorytab-tabswitch"
                onClick={() => {
                    try {
                    tabSwitch(id);
                     } catch (error) {
                         logErrorToConsole(error);
                     }
                }}
                isSelected={isTabActive}
                cursor={'pointer'}
            >
                <TabContent isPending={false} isBatch={false}>
                    <TabContentFont
                        isSelected={isTabActive}
                        width={isLanguageChanged && 'max-content'}
                    >
                        {label}
                    </TabContentFont>
                </TabContent>
                <TabSelectedBorder isSelected={isTabActive} />
            </StyledTabContentContianer>
        </>
    );
};

export default InventoryTabList;
